window['assignments#new'] = function () {
  const onlyUnique = function (value, index, self) {
    return self.indexOf(value) === index
  }
  $('a.classification-tag').on('click', function () {
    const selectBox = $('#add_ids').select2()
    let selected = selectBox.val()
    const suitable = $(this).attr('data-partner-ids').split(',')
    selected = selected.concat(suitable)
    const vals = selected.filter(onlyUnique)
    selectBox.val(vals).trigger('change')
    $('#positions_assign_partners').modal('hide')
  })
}
